module.exports = __webpack_public_path__ + "static/media/Lens-Fresh Green.ac942a49.png";